import { graphql } from "gql";

const EDIT_MESSAGE_THREAD_SUBJECT_MUTATION = graphql(`
  mutation EditMessageThreadSubject($id: ID!, $subject: String) {
    editMessageThread(id: $id, input: { subject: $subject }) {
      id
      subject
    }
  }
`);

export default EDIT_MESSAGE_THREAD_SUBJECT_MUTATION;
